import { PostService } from "@lib/strapi/services/content-types/post.service";
import { StrapiPages } from "@lib/strapi/pages";
import {
  StrapiPostCategoryDTO,
  PostCategoryDTO,
} from "@lib/strapi/dtos/content-types/postCategory.dto";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import { fetchAPI } from "@lib/strapi/fetch-api";

export class PostCategoryService {
  static async fromStrapi(
    dto: PostCategoryDTO,
    locale: string,
    strapiData?: StrapiPostCategoryDTO,
  ): Promise<PostCategoryDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new PostCategoryDTO();
    }
    dto.name = strapiData.name;
    dto.slug = strapiData.slug;
    dto.description = strapiData.description;
    dto.sortIndex = strapiData.sortIndex;
    dto.posts = await Promise.all(
      (strapiData.posts ?? []).map(
        async (item) => await PostService.fromStrapi(null, locale, item),
      ),
    );
    return dto;
  }

  static async fetchAll(
    authToken: string,
    locale: string,
  ): Promise<PostCategoryDTO[]> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = {
      locale,
      sort: ["sortIndex:asc"],
      pagination: { pageSize: 200 },
    };
    const response: StrapiResponse<StrapiPostCategoryDTO[]> = await fetchAPI(
      StrapiRoutes.postCategories(),
      urlParamsObject,
      token,
    );
    const dto = new PostCategoryDTO();
    return await Promise.all(
      (response.data ?? []).map(
        async (item) =>
          await PostCategoryService.fromStrapi(
            new PostCategoryDTO(),
            locale,
            item,
          ),
      ),
    );
  }

  static async fetchBySlug(
    authToken: string,
    locale: string,
    slug?: string,
  ): Promise<PostCategoryDTO> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale, filters: { slug: slug } };
    const response: StrapiResponse<StrapiPostCategoryDTO[]> = await fetchAPI(
      StrapiRoutes.postCategories(),
      urlParamsObject,
      token,
    );
    const dto = new PostCategoryDTO();
    if ((response.data ?? []).length === 0) {
      return null;
    }
    return await PostCategoryService.fromStrapi(
      dto,
      locale,
      (response.data ?? [])[0],
    );
  }
}
